import React, { useRef, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { getDept } from '../utils/index';
import Map from '../components/Mapa/index';
import { getOptionGanadores } from '../data/mapaGanadores';
import { getOptionCalor } from '../data/mapaCalor';
import { useIsDesktop, useIsMobile } from '../hooks/useMediaQuery';
import styled from 'styled-components/macro';
import SelectMapa from '../containers/SelectMapa';
import { useMap } from '../contexts/mapContext';
import { responsive } from '../resources/constantes.json';
import { themes } from '../styles/themes';
import MapErrorBoundary from '../components/Mapa/MapErrorBoundary';

const Mapa = ({ ...rest }) => {
  const { selectedMap, setSelectedMap, setTooltipProps } = useMap();

  const [offset, setOffset] = useState(0);

  useEffect(() => {
    window.onscroll = () => {
      setOffset(window.pageYOffset);
    };
  }, []);

  switch (selectedMap.variant) {
    case 'resultados':
      return (
        <MapaResultados
          setElecMapa={setSelectedMap}
          offset={offset}
          page={selectedMap.variant}
          mapOpt={selectedMap}
          setTooltipProps={setTooltipProps}
          {...rest}
        />
      );
    case 'inicio':
      return (
        <MapaInicio
          setElecMapa={setSelectedMap}
          offset={offset}
          page={selectedMap.variant}
          mapOpt={selectedMap}
          setTooltipProps={setTooltipProps}
          {...rest}
        />
      );
    default:
      return null;
  }
};

const MapaResultados = props => {
  const nDep = getDept(props.amb, props.citrep);
  const stateRef = useRef({ x: 0, y: 0 });
  const isDesktop = useIsDesktop();
  const { mapDomRef, selectedMap } = useMap();
  const [mapFeatures, setMapFeatures] = useState();

  return (
    <ArticleMapa offset={props.offset}>
      <ColDiv>
        <SelectMapa
          elec={props.mapOpt}
          setElec={props.setElecMapa}
          nomenclator={props.nomenclator}
        />
      </ColDiv>
      <div>
        <div>
          <SMapWrapper ref={mapDomRef}>
            <MapErrorBoundary>
              <Map
                key={`${selectedMap.id}-${props.eleccion}`}
                getOption={getOptionGanadores(
                  props.data,
                  nDep,
                  props.amb,
                  props.nomenclator,
                  stateRef,
                  isDesktop,
                  props.mapOpt,
                  props.camaraSeleccionada,
                  props.setTooltipProps
                )}
                setMapFeatures={setMapFeatures}
                width="100%"
                height="80vh"
                name={nDep}
                citrep={props.citrep}
                eventsProps={{
                  history: props.history,
                  nomenclator: props.nomenclator,
                  eleccion: props.eleccion,
                  esHistorico: props.esHistorico,
                  page: props.page,
                }}
              />
            </MapErrorBoundary>
          </SMapWrapper>
        </div>
      </div>
    </ArticleMapa>
  );
};

const MapaInicio = props => {
  const nDep = getDept(props.amb, props.citrep);
  const stateRef = useRef({ x: 0, y: 0 });
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();
  const [mapFeatures, setMapFeatures] = useState();
  const { mapDomRef, selectedMap } = useMap();

  return (
    <ArticleMapa
      offset={props.offset}
      style={{
        backgroundColor: themes.inicio.backgroundColor,
        borderRadius: '25px',
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center',
        position: 'relative',
        paddingTop: isMobile ? '50px' : '',
      }}
    >
      {props.children}
      <div style={{ width: '100%', height: '100%' }}>
        <div style={{ height: '100%' }}>
          <SMapWrapper ref={mapDomRef} style={{ height: '100%' }}>
            <MapErrorBoundary>
              <Map
                key={`${selectedMap.id}-10`}
                getOption={getOptionCalor(
                  props.data,
                  nDep,
                  props.amb,
                  props.nomenclator,
                  props.mapOpt,
                  stateRef,
                  isDesktop,
                  isMobile,
                  mapFeatures,
                  props.mapData,
                  props.eleccion,
                  props.setTooltipProps
                )}
                setMapFeatures={setMapFeatures}
                width="100%"
                height="100%"
                minHeight="70vh"
                name={nDep}
                citrep={props.citrep}
                eventsProps={{
                  history: props.history,
                  nomenclator: props.nomenclator,
                  eleccion: '10',
                  esHistorico: props.esHistorico,
                  page: props.page,
                }}
              />
            </MapErrorBoundary>
          </SMapWrapper>
        </div>
      </div>
    </ArticleMapa>
  );
};
const ColDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

/* const MapaSectores = props => {
  const nDep = getDepartamento(props.amb, props.nomenclator, props.eleccion);
  const stateRef = useRef({ x: 0, y: 0 });
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();
  const parentLevel = useParentLevel();
  const [mapFeatures, setMapFeatures] = useState();
  const options = getOptionSectores(
    props.data,
    nDep,
    props.amb,
    props.nomenclator,
    props.mapOpt,
    stateRef,
    isDesktop,
    mapFeatures,
    props.camaraIndex,
    props.eleccion
  );
  return (
    <ArticleMapa offset={props.offset}>
      <header>
        <SelectMapa elec={props.mapOpt} setElec={props.setElecMapa} />
      </header>
      <div>
        <div css="height: 85vh;">
          <SMapWrapper>
            <Map
              getOption={options}
              setMapFeatures={setMapFeatures}
              width="100%"
              height="75vh"
              name={nDep}
              onEvents={getOnEvents(
                props.history,
                props.nomenclator,
                props.page,
                props.eleccion,
                props.mapOpt,
                parentLevel,
                props.esHistorico
              )}
            />
            {
              // <SLeyendaWrapper>
              //   {options.leyendas.map((leyenda) => {
              //     return (
              //       <div
              //       css="display: flex; align-items:center; max-width: 20rem;">
              //         <BarraLeyenda color={leyenda.color} />
              //         <p css="font-size: 10px; line-height: 15px;">
              //           {leyenda.label}
              //         </p>
              //       </div>
              //     );
              //   })}
              // </SLeyendaWrapper>
            }
          </SMapWrapper>
        </div>
      </div>
    </ArticleMapa>
  );
}; */

export default withRouter(Mapa);

const SLeyendaWrapper = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
  box-sizing: content-box;
  margin: 0px 2rem;
  @media print {
    position: absolute;
    top: 70%;
    left: 25%;
  }
`;

const SMapWrapper = styled.article`
  width: 100%;
  height: 85%;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  @media print {
    display: block;
  }
  @media (max-width: ${responsive.mobile}px) {
    height: 50vh;
    margin-top: 5rem;
  }
`;

const BarraLeyenda = styled(({ color = 'red', ...rest }) => <span {...rest} />)`
  width: 20px;
  height: 25px;
  background-color: ${({ color }) => color};
  margin-right: 5px;
  border-radius: 5px;
  border: solid 1px;
  flex: 0 0 20px;
`;

const ArticleMapa = styled.article`
  right: 0;
  width: 100%;
  height: 100%;
  @media (max-width: 1024px) {
    position: relative;
    width: 100%;
  }
  @media print {
    position: relative;
    width: 100%;
    page-break-before: always;
    @media print {
      display: block;
      top: 0;
    }
  }
`;
